import React from 'react';
import useUserFullName from 'store/useUserFullName';

function UserFullName(props: { id: string }) {
  return <>{useUserFullName(props.id)}</>;
}

export default React.memo(UserFullName);
